module.exports = __webpack_public_path__ + "static/img/store4.c7758c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/store4.jpg
// module id = ZUU8
// module chunks = 1